import React, { useState } from 'react';
import Rating from '@material-ui/lab/Rating';
import { withStyles } from '@material-ui/core/styles';
import Icon from 'components/Utils/NewIcon';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { api } from 'careand-redux/api/ApiThunks';
import { useAppSelector } from 'careand-redux/store';
import { IsPatient } from 'careand-redux/selectors';

const StyledRating = withStyles({
  label: {
    height: '60px',
    padding: '0px 10px',
  },
})(Rating);

const AppointmentRating = ({ appointment }) => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const isPatient = useAppSelector(IsPatient);

  async function onRate(rating) {
    setLoading(true);
    await dispatch(api.Appointments.rateAppointment({ id: appointment.id, rating }), {
      errorTitle: 'Appointment Rating',
    });
    setLoading(false);
  }

  const isDisabled = !isPatient || loading || appointment.rating !== undefined;

  return (
    <>
      {!isDisabled ? <span className="rate-title">Please rate your appointment</span> : null}
      <StyledRating
        value={appointment.rating}
        max={5}
        emptyIcon={<Icon src="star" fontAwesomeStyle="far" width="30px" />}
        icon={<Icon src="star" fontAwesomeStyle="fas" width="30px" />}
        disabled={isDisabled}
        onChange={(event, newValue) => onRate(newValue)}
      />
    </>
  );
};

export default AppointmentRating;
